<template>
<div class="container-fluid d-flex flex-fill flex-column scrollable">
  <b-toast id="dbinfo" title="Getting started" static no-auto-hide></b-toast>
  <!-- main UI -->
  <div class="row d-flex flex-fill scrollable">
    <div class="col-3 d-flex flex-fill scrollable" style="max-height: 100%">
      <TableColumns></TableColumns>
    </div>
    <div class="col-9">
      <PlanToText/>
      <QA/>
    </div>
  </div>
  <footer class="icp-footer">
    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">陕ICP备2021012794号-1</a>
  </footer>
</div>
</template>

<script>
import PlanToText from './PlanToText.vue'
import QA from './QA.vue'
import TableColumns from './TableColumns.vue'

export default {
  data: function() {
    return {
      // dbinfo: "You've been connected to the TPCH database. To switch between this and the IMDB database, click 'Switch DB' in the navigation bar. Your preference will be saved for furture access.",
      showOverlay: true
    }
  },
  components: {
    PlanToText,
    QA,
    TableColumns
  },
}
</script>
